<template>
  <validation-provider
      v-slot="{ valid, errors, required, reset, invalid, dirty }"
      :class="formGroupClassComputed"
      :customMessages="validateCustomMessages"
      :disabled="validateDisabled"
      :name="label"
      :rules="validateRules"
      :vid="validateVid"
      :detectInput="true"
      class="form-group"
      tag="div"
  >
    <slot name="label">
      <label v-if="!labelInvisible"
             :class="{...labelClassComputed, 'required': required}"
             :for="id"
             class="control-label"
      >
        {{ label }}
      </label>
    </slot>

    <div v-if="inline" :class="inputWrapperClass">
      <slot v-bind="{ valid, errors, required, reset, invalid, dirty }"></slot>
    </div>
    <slot v-else v-bind="{ valid, errors, required, reset, invalid, dirty }"></slot>
  </validation-provider>
</template>

<script>
export default {
  name: "CFormGroup",
  props: {
    id: String,
    formGroupClass: String,
    hasFeedback: Boolean,
    inline: Boolean,
    inputWrapperClass: String,
    label: String,
    labelClass: String,
    labelRight: Boolean,
    labelInvisible: Boolean,
    validateVid: String,
    validateRules: [Object, String],
    validateDisabled: Boolean,
    validateCustomMessages: Object
  },
  computed: {
    labelClassComputed() {
      let obj = {
        'col-form-label': this.inline,
        'label-align': this.labelRight
      }
      if (this.labelClass) {
        obj[this.labelClass] = true
      }
      return obj;
    },
    formGroupClassComputed() {
      let obj = {
        'has-feedback': this.hasFeedback,
        'row': this.inline
      }
      obj[this.formGroupClass] = this.formGroupClass;
      return obj;
    },
  },
  data() {
    return {
      tag: {
        type: String,
        default: "div"
      },
    }
  }
}
</script>

<style scoped>

</style>